var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.type !== "bic"
    ? _c(
        "router-link",
        {
          class: _vm.linkClass,
          attrs: {
            "data-ref-id": _vm.bicref.id,
            "data-gtm-category": "Cross Reference",
            "data-gtm-action": _vm.bicref.type,
            "data-gtm-label": _vm.bicref.desc,
            to: _vm.linkTo,
          },
        },
        [_vm._v("\n  " + _vm._s(_vm.bicref.desc) + "\n")]
      )
    : _c(
        "a",
        {
          class: _vm.linkClass,
          attrs: {
            "data-ref-id": _vm.bicref.id,
            "data-gtm-category": "Cross Reference",
            "data-gtm-action": _vm.bicref.type,
            "data-gtm-label": _vm.bicref.desc,
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return (() => _vm.click({ id: _vm.bicref.id })).apply(
                null,
                arguments
              )
            },
          },
        },
        [_vm._v("\n " + _vm._s(_vm.bicref.desc) + "\n")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }